import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Nav, { NavItem } from 'tbk-components/src/components/Nav';
import SocialIcons, { ISocialIconsProps } from '../SocialIcons';

export interface IFooterBottomProps extends IBaseElementProps {
	socialIcons?: ISocialIconsProps;
	copyrightText?: string;
	bottomMenu?: NavItem[];
}

const FooterBottom: React.FC<IFooterBottomProps> = ({
	className,
	classNames = [],
	socialIcons,
	copyrightText,
	bottomMenu,
}) => (
	<div
		className={
			className ||
			cn('calian-footer__bottom container-fluid', ...classNames)
		}
	>
		<div className="calian-footer__bottom--content container">
			<div className="calian-footer__bottom--content-left">
				{socialIcons && (
					<SocialIcons
						className="calian-footer__bottom--social-icons list-unstyled"
						{...socialIcons}
					/>
				)}
				{copyrightText && (
					<p className="calian-footer__copyright">{copyrightText}</p>
				)}
				{bottomMenu && (
					<Nav
						navItems={bottomMenu}
						collapseEnabled={false}
						dropdownEnabled
						classNames={['calian-footer__bottom-nav']}
					/>
				)}
			</div>
			<div className="calian-footer__bottom--content-left">
				<div className="calian-footer__tbk-container">
					<a
						href="https://tbkcreative.com/?ref=calian"
						target="_blank"
						className="footer__tbk"
						rel="noreferrer noopener"
					>
						<span>Web Design &amp; Digital Marketing </span>
						<i className="icon icon-tbk-logo" />
					</a>
				</div>
			</div>
		</div>
	</div>
);

export default FooterBottom;
